import { ReactElement } from 'react'
import { Result } from 'antd'

import coffeeBreak from '../../assets/img/coffee-break.png'

/**
 * Shown to a participant when the participation session for a decision is not
 * active (closed). Uses the "coffee break" illustration to convey "come back
 * later," matching the illustrated `<Result>` treatment used elsewhere.
 */
export function ParticipationClosedResult(): ReactElement {
  return (
    <Result
      icon={<img src={coffeeBreak} alt="" style={{ width: 240, maxWidth: '100%', height: 'auto' }} />}
      title="Break Time"
      subTitle={
        <span style={{ fontSize: 16, color: 'rgba(0, 0, 0, 0.65)' }}>
          Participation for this decision is currently closed.
          <br />
          Please contact the decision facilitator for more information.
        </span>
      }
    />
  )
}
